/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ValidationIssueResponseCode = typeof ValidationIssueResponseCode[keyof typeof ValidationIssueResponseCode];


export const ValidationIssueResponseCode = {
  variable_missing_required: 'variable_missing_required',
  contact_email_missing: 'contact_email_missing',
  contact_email_invalid: 'contact_email_invalid',
  linkedin_url_missing: 'linkedin_url_missing',
  mailbox_disconnected: 'mailbox_disconnected',
  linkedin_account_disconnected: 'linkedin_account_disconnected',
  sequence_not_active: 'sequence_not_active',
  step_set_changed: 'step_set_changed',
  duplicate_active_enrollment: 'duplicate_active_enrollment',
  credit_insufficient: 'credit_insufficient',
  linkedin_daily_cap_exceeded: 'linkedin_daily_cap_exceeded',
  candidate_unsubscribed: 'candidate_unsubscribed',
  candidate_excluded: 'candidate_excluded',
} as const;
